<nav data-cy="navbar" class="navbar navbar-dark navbar-expand-md bg-dark">
  <div class="container-fluid">
    <a class="navbar-brand logo" routerLink="/" (click)="collapseNavbar()">
      <span class="logo-img"></span>
      <span jhiTranslate="global.title" class="navbar-title">xcare</span>
    </a>
    <a
      class="navbar-toggler d-lg-none"
      href="javascript:void(0);"
      data-toggle="collapse"
      data-target="#navbarResponsive"
      aria-controls="navbarResponsive"
      aria-expanded="false"
      aria-label="Toggle navigation"
      (click)="toggleNavbar()"
    >
      <fa-icon icon="bars"></fa-icon>
    </a>
    <div class="navbar-collapse collapse" id="navbarResponsive" [ngbCollapse]="isNavbarCollapsed">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" routerLink="/" (click)="collapseNavbar()">
            <span>
              <fa-icon icon="home"></fa-icon>
              <span jhiTranslate="global.menu.home">news</span>
            </span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" routerLink="/sexualbegleiterin" (click)="collapseNavbar()">
            <span>
              <fa-icon icon="heart"></fa-icon>
              <span jhiTranslate="global.menu.ads">Sedcards</span>
            </span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" routerLink="/medien" (click)="collapseNavbar()">
            <span>
              <fa-icon icon="newspaper"></fa-icon>
              <span jhiTranslate="global.menu.medias">medien</span>
            </span>
          </a>
        </li>
        <li
          ngbDropdown
          class="nav-item dropdown pointer"
          display="dynamic"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="info-menu" data-cy="info">
            <span>
              <fa-icon icon="circle-info"></fa-icon>
              <span jhiTranslate="global.menu.infos.main">Infos</span>
            </span>
          </a>
          <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="info-menu">
            <li>
              <a
                class="dropdown-item"
                routerLink="/info/program"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="collapseNavbar()"
              >
                <fa-icon icon="rectangle-list" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.infos.program">Program</span>
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                routerLink="/info/infos-fur-anbieterinnen"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="collapseNavbar()"
              >
                <fa-icon icon="user-graduate" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.infos.education">Ausbildung</span>
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                routerLink="/info/faq"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="collapseNavbar()"
              >
                <fa-icon icon="circle-question" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.infos.faq">FAQ</span>
              </a>
            </li>
          </ul>
        </li>
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" routerLink="/angebote-fur-institutionen" (click)="collapseNavbar()">
            <span>
              <fa-icon icon="building-columns"></fa-icon>
              <span jhiTranslate="global.menu.institutions">angebote-fur-institutionen</span>
            </span>
          </a>
        </li>
        @if (account !== null && !account.authorities.includes("ROLE_ADMIN")) {
          <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link" routerLink="/messenger" (click)="collapseNavbar()">
            <span>
              <fa-icon icon="comments"></fa-icon>
              <span jhiTranslate="global.menu.entities.message">Nachrichten</span>
            </span>
            </a>
          </li>
        }
        <li
          *jhiHasAnyAuthority="'ROLE_ADMIN'"
          ngbDropdown
          class="nav-item dropdown pointer"
          display="dynamic"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="entity-menu" data-cy="entity">
            <span>
              <fa-icon icon="th-list"></fa-icon>
              <span jhiTranslate="global.menu.entities.main">Entitäten</span>
            </span>
          </a>
          <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="entity-menu">
            <li>
              <a
                class="dropdown-item"
                routerLink="/sedcard"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="collapseNavbar()"
              >
                <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.entities.sedcard">Sed Card</span>
              </a>
            </li>
            <li>
              <a
                class="dropdown-item"
                routerLink="/message"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="collapseNavbar()"
              >
                <fa-icon icon="asterisk" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.entities.message">Message</span>
              </a>
            </li>
          </ul>
        </li>
        <li
          *jhiHasAnyAuthority="'ROLE_ADMIN'"
          ngbDropdown
          class="nav-item dropdown pointer"
          display="dynamic"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="admin-menu" data-cy="adminMenu">
            <span>
              <fa-icon icon="users-cog"></fa-icon>
              <span jhiTranslate="global.menu.admin.main">Administration</span>
            </span>
          </a>
          <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="admin-menu">
            <li>
              <a class="dropdown-item" routerLink="/admin/user-management" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="users" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.admin.userManagement">Benutzerverwaltung</span>
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/admin/metrics" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="tachometer-alt" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.admin.metrics">Metriken</span>
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/admin/health" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="heart" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.admin.health">Status</span>
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/admin/configuration" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="cogs" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.admin.configuration">Konfiguration</span>
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/admin/logs" routerLinkActive="active" (click)="collapseNavbar()">
                <fa-icon icon="tasks" [fixedWidth]="true"></fa-icon>
                <span jhiTranslate="global.menu.admin.logs">Protokoll</span>
              </a>
            </li>
            @if (openAPIEnabled) {
              <li>
                <a class="dropdown-item" routerLink="/admin/docs" routerLinkActive="active" (click)="collapseNavbar()">
                  <fa-icon icon="book" [fixedWidth]="true"></fa-icon>
                  <span jhiTranslate="global.menu.admin.apidocs">API</span>
                </a>
              </li>
            }
          </ul>
        </li>
        <li
          ngbDropdown
          class="nav-item dropdown pointer"
          display="dynamic"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a class="nav-link dropdown-toggle" ngbDropdownToggle href="javascript:void(0);" id="account-menu" data-cy="accountMenu">
            @if (!account?.imageUrl) {
              <span>
                <fa-icon icon="user"></fa-icon>
                <span jhiTranslate="global.menu.account.main">Zugang</span>
              </span>
            } @else {
              <span>
                <img [src]="account!.imageUrl" class="profile-image rounded-circle" alt="Avatar" />
              </span>
            }
          </a>
          <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="account-menu">
            @if (account !== null) {
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/account/settings"
                  routerLinkActive="active"
                  (click)="collapseNavbar()"
                  data-cy="settings"
                >
                  <fa-icon icon="wrench" [fixedWidth]="true"></fa-icon>
                  <span jhiTranslate="global.menu.account.settings">Einstellungen</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/account/password"
                  routerLinkActive="active"
                  (click)="collapseNavbar()"
                  data-cy="passwordItem"
                >
                  <fa-icon icon="lock" [fixedWidth]="true"></fa-icon>
                  <span jhiTranslate="global.menu.account.password">Passwort</span>
                </a>
              </li>
              <li>
                <a class="dropdown-item" (click)="logout()" id="logout" data-cy="logout">
                  <fa-icon icon="sign-out-alt" [fixedWidth]="true"></fa-icon>
                  <span jhiTranslate="global.menu.account.logout">Abmelden</span>
                </a>
              </li>
            } @else {
              <li>
                <a class="dropdown-item" (click)="login()" id="login" data-cy="login">
                  <fa-icon icon="sign-in-alt" [fixedWidth]="true"></fa-icon>
                  <span jhiTranslate="global.menu.account.login">Anmelden</span>
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  routerLink="/account/register"
                  routerLinkActive="active"
                  (click)="collapseNavbar()"
                  data-cy="register"
                >
                  <fa-icon icon="user-plus" [fixedWidth]="true"></fa-icon>
                  <span jhiTranslate="global.menu.account.register">Registrierung</span>
                </a>
              </li>
            }
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
